import PropTypes from 'prop-types';
import { getCookie, isLoggedIn, pdcAEMCheck } from '../../common/Helpers/index';

import { eventDispatcher } from '../../common/Tagging';

const getShortDayFormat = (date) => date?.toLocaleString('en-US', { weekday: 'short' });
// export const daysArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// '10:00 AM 08:00 PM', => 10 AM - 08 PM
export const formatStoreHours = (storeHours) => {
  if (!storeHours || storeHours.toLowerCase().indexOf('closed') > -1) {
    return storeHours || '';
  }

  const formatHours = storeHours.replaceAll(':00', '').replace('AM ', 'AM - ');

  return formatHours;
};

// hoursMon: '10:00 AM 08:00 PM', => Mon, 10 AM - 08 PM
export const getStoreHours = (store, isLimitedCurb) => {
  const myDate = new Date();
  const Nextday = new Date(myDate);
  // let isStoreClosedToday = store[`hours${moment(myDate).format('ddd')}`]?.includes('Closed');
  let isStoreClosedToday = store[`hours${getShortDayFormat(myDate)}`]?.includes('Closed');

  if (!isStoreClosedToday) {
    Nextday.setDate(Nextday.getDate() + 1);
  }
  // isStoreClosedToday = store[`hours${moment(Nextday).format('ddd')}`]?.includes('Closed');
  isStoreClosedToday = store[`hours${getShortDayFormat(Nextday)}`]?.includes('Closed');

  let i = 0;
  while (isStoreClosedToday) {
    i = 1;
    Nextday.setDate(Nextday.getDate() + i);
    // isStoreClosedToday = store[`hours${moment(Nextday).format('ddd')}`]?.includes('Closed');
    isStoreClosedToday = store[`hours${getShortDayFormat(Nextday)}`]?.includes('Closed');

    if (!isStoreClosedToday) {
      i = 0;
      break;
    }
  }
  const loginHours = myDate.getHours();
  // const myDateName = moment(myDate).format('ddd');
  // const NextDateName = moment(Nextday).format('ddd');

  const myDateName = getShortDayFormat(myDate);
  const NextDateName = getShortDayFormat(Nextday);

  const storeHours = isLimitedCurb ? 16 : parseInt(`${store[`hours${myDateName}`]}`?.split('AM ')[1]?.split(':')[0]) + 12;

  // const availableDay = store[`hours${moment(myDate).format('ddd')}`]?.includes('Closed') || loginHours >= storeHours ? NextDateName : myDateName;
  const availableDay = store[`hours${getShortDayFormat(myDate)}`]?.includes('Closed') || loginHours >= storeHours ? NextDateName : myDateName;

  const availableTime = isLimitedCurb ? '09 AM - 04 PM' : formatStoreHours(store[`hours${availableDay}`]);

  return `${availableDay}, ${availableTime}`;
};

export const shippingCommon = (thisVal, store) => {
  if (thisVal.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0) {
    store.dispatch({ type: 'CLEAR_CREDIT_CHECK_RESPONSE' });
  }
  // this.props.getDetailsFromApi();
  thisVal.props.showCart(false);
  store.dispatch({ type: 'RESET_ISPU_MODAL' });
  thisVal.setState({
    selectedShippingOption: thisVal.props.selectedShippingOption,
  });
  const data = {
    pageName: 'shipping',
  };
  if (!isLoggedIn() && pdcAEMCheck()) {
    thisVal.props.updatePdc(data);
  }
  store.dispatch({ type: 'CEF_SHIPPING_INFO_ERROR', response: false, errorMessage: null });
};

export const universalProfileMethod = (propsVal, cradleThrottleList) => {
  if (propsVal.universalProfileCreationStatus === 'success') {
    eventDispatcher('sendData', {
      name: '',
      data: {
        page: {
          contentFragments: 'Your My Verizon account was created successfully',
          name: 'displayshippingoptions',
        },
      },
      svars: {
        evar22: 'Account creation success - self setup',
        evar64: 'shell account fwa',
        evar221: 'shell acc fwa',
        evar220: cradleThrottleList,
      },
    });
  } else if (propsVal.universalProfileCreationStatus === 'error') {
    // window.vzdl.page.contentFragment = 'Account not created';
    eventDispatcher('sendData', {
      name: '',
      data: {
        page: {
          contentFragments: 'Account not created',
          name: 'displayshippingoptions',
        },
      },
      svars: {
        evar13: 'Account not created',
        evar22: 'Account creation fail - self setup',
        evar64: 'shell account fwa',
        evar221: 'shell acc fwa',
        evar220: cradleThrottleList,
      },
    });
  }
};

export const securePinProps = {
  modalChanged: PropTypes.func,
  cancelUpdated: PropTypes.func,
  securePinSendSMS: PropTypes.func,
  securePinValidateAuthCode: PropTypes.func,
  // CloseModel: PropTypes.func,
  // shippingAddressProps: PropTypes.object,
  devices: PropTypes.array,
  securePinDataDeviceSucess: PropTypes.object,
  updateValidateOTPResponse: PropTypes.string,
  validateOTPError: PropTypes.string,
  isMaxAttemptsExceeded: PropTypes.bool,
  addressChangeRequired: PropTypes.any,
  CONTACT_INFO_AUTH_CODE_SUMMARY: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_HOW_TO_TITLE: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_SENT_SUMMARY: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_ENTER_CODE: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_CONFIRM_CODE: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_CANCEL_CTA: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_RESEND_CODE: PropTypes.string,
  CONTACT_INFO_AUTH_CODE_HEAD: PropTypes.string,
};

export const secureDefaultProps = {
  CONTACT_INFO_AUTH_CODE_SUMMARY:
    "It looks like you picked a different address than the billing address we have on your account. Not a problem, we'll just need to text you a confirmation code to continue.",
  CONTACT_INFO_AUTH_CODE_HOW_TO_TITLE: "Here's how to get your code:",
  CONTACT_INFO_AUTH_CODE_SENT_SUMMARY: 'Please enter the code that was sent to your line.',
  CONTACT_INFO_AUTH_CODE_ENTER_CODE: 'Enter authorization code',
  CONTACT_INFO_AUTH_CODE_CONFIRM_CODE: 'Confirm authorization code',
  CONTACT_INFO_AUTH_CODE_CANCEL_CTA: 'Cancel',
  CONTACT_INFO_AUTH_CODE_RESEND_CODE: 'Resend code',
  CONTACT_INFO_AUTH_CODE_HEAD: 'Online Authorization Code',
};

export const isIndirectStoresEnabled = () => !!(getCookie('cdlThrottleList') && getCookie('cdlThrottleList')?.includes('FWA_Indirect_T_Stores'));
